module.exports = __webpack_public_path__ + "img/symbol_3.ad9aba09.png";